module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-2-2701f988c5c579dadd5c8a88512ca79a.svg";